import React, { useState, useEffect, useRef } from 'react';
import { Modal, ModalContent, ModalHeader } from 'semantic-ui-react';


type Payment2C2PModalProps = {
  webPaymentUrl: string;
}
// const Payment2C2PModal = (props: any) => {






//   return (<>
//     <Modal
//       open={true}
//       size="fullscreen"
//     >
//       <ModalContent>
//         <button id="button_payment_ui" type="button" onClick={() => {
//           const uiRequestMandatory = {

//             url: props.webPaymentUrl
//           };

//           //or

//           const uiRequestFull = {

//             url: props.webPaymentUrl,
//             templateId: "ikea",
//             mode: "DropIn",
//             appBar: true,
//             cancelConfirmation: true
//           };

//           PGWSDK.paymentUI(uiRequestFull, function (response) {

//             console.log(response);

//             if (response.responseCode == "0003") {

//               //User canceled transaction
//             } else if (response.responseCode == "2000") {

//               let transactionStatusInquiry = response.transactionStatusInquiry;

//               if (transactionStatusInquiry) {

//                 //Handle transaction status inquiry API response or redirect to your payment result page.
//               } else {

//                 //Request payment inquiry API or redirect to your payment result page.
//               }
//             } else {

//               console.log("Response callback: " + response.paymentToken + " // " + response.responseCode + " // " + response.responseDescription);
//             }
//           });
//         }
//         }>Submit Payment UI</button>
//         <button id="button_payment_submit" type="button" onClick={() => {
//           PGWSDK.submitPayment("submit_gcard")
//         }}>Submit Payment Submit</button>


//       </ModalContent>
//     </Modal>
//   </>)
// }
const Payment2C2PModal = (props: Payment2C2PModalProps) => {
  const [open, setOpen] = useState(true)

  // const iframeRef = useRef(null);

  useEffect(() => {
    // Handle payment post messages
    const handlePaymentPostMessages = ({ data }) => {
      const { paymentResult } = data;

      if (paymentResult) {
        console.log('paymentResult: ', paymentResult);
        const { respCode, respDesc, respData } = paymentResult;

        // Handle response codes
        alert(`${respCode}: ${respDesc}: ${respData}`);

        if (respCode === '2000') {
          props.runSequence({ sequence: "BillingAndPackage", action: "2C2P_SUCCESS" })
          setOpen(false)

        }

        // if (respCode === '1001') {
        //   alert('Redirect to continue payment');
        //   window.location.replace(respData);
        // }
      }
    };

    // Subscribe to post messages
    window.addEventListener('message', handlePaymentPostMessages);

    // Cleanup listener on unmount
    return () => {
      window.removeEventListener('message', handlePaymentPostMessages);
    };
  }, []);



  // const triggerSubmitPayment = (paymentType = 'submit_gcard') => {
  //   if (iframeRef.current) {
  //     // Possible types to trigger:
  //     // submit_gcard     - Global Credit Card
  //     // submit_lcard     - Local Credit Card
  //     // submit_dpay      - Digital Payment
  //     // submit_qr        - QR Payment
  //     // submit_counter   - Counter Payment
  //     // submit_ssm       - Self Service Machine
  //     // submit_webpay    - Web Payment / Direct Debit
  //     // submit_imbank    - iBanking / mBanking
  //     // submit_gbnpl     - Global Buy Now Pay Later

  //     iframeRef.current.contentWindow.postMessage(paymentType, '*');
  //   }
  // };

  return (
    <Modal
      open={open}
      style={{height: "50%"}}
      size="large"
    >
   
      <iframe
        // ref={iframeRef}
        name="output_frame"
        id="output_frame"
        src={props.webPaymentUrl}
        width="100%"
        height="100%"
        style={{ border: '1px solid #ccc', marginTop: '20px' , minHeight: "100%"}}
        title="Payment Gateway"
      />
     
    </Modal>

  );
};

export default Payment2C2PModal;